module.exports = "/images/vendor/flag-icon-css/flags/1x1/gm.svg?414139d5039a0584ac0475034a3ad8c7";